import { onboardingStore } from "../auth/onboardingStore";
import { emptyProfileAnswers } from "../domain/answers";
import type { MediaAsset } from "../domain/types";
import { initialAnswers } from "../flow/FlowContext";
import { STEP_ORDER } from "../flow/steps";

/** Write ID / video onto the current user's onboarding row without moving their step. */
export function saveVerifyMedia(
  userId: string,
  patch: {
    governmentId?: MediaAsset | null;
    confirmationVideo?: MediaAsset | null;
  }
): void {
  const row = onboardingStore.load(userId);
  const answers = {
    ...(row?.answers ?? initialAnswers),
    ...patch,
  };
  const fallback = STEP_ORDER.indexOf("profile");
  const stepIndex = row?.stepIndex ?? (fallback >= 0 ? fallback : 0);
  onboardingStore.save(
    userId,
    stepIndex,
    answers,
    row?.profileAnswers ?? emptyProfileAnswers()
  );
}
